import { Button, FormControl, FormLabel, IconButton, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Stack, Text, useDisclosure } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

import { EditIcon } from '@chakra-ui/icons';
import { deliveryType } from '../../../types';
import moment from 'moment';
import { updateDeliveryDateTime } from '../../../store/actions';
import { useAppDispatch } from '../../../hooks';

export const DateTimeUpdater = (props: { delivery?: deliveryType; }) => {

    const { delivery  } = props;

    const { isOpen, onOpen, onClose } = useDisclosure();

    const [isUpdating, setUpdating] = useState<boolean>(false);
    const [date, setDate] = useState<string>('');

    const dispatch = useAppDispatch();

    const updateDeliveryDate = () => {
        setUpdating(true);
        dispatch(updateDeliveryDateTime({
            delivery_id: delivery?.delivery_id,
            date,
            time: moment(date).format('HH:mm')
        }))
        .then(() => {
            setUpdating(false);
            onClose();
            setDate('');
        })
        .catch(() => {
            setUpdating(false);
        });
    };

    useEffect(() => {}, [date]);

    return (
        <>
            <IconButton aria-label={''} icon={<EditIcon />} size={'xs'} onClick={onOpen}></IconButton>
            <Modal isOpen={isOpen} onClose={onClose} isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Update Date and Time</ModalHeader>
                    <ModalCloseButton colorScheme={'yellow'} />
                    <ModalBody>
                        <Stack>
                            <Stack bg={'green.200'} borderRadius={3} p={3}>
                                <Text fontSize={'xs'} color={'green'}><strong>Current Date and  Time:</strong> {moment(delivery?.date).format('YYYY-MM-DD')} | {delivery?.time}</Text>
                            </Stack>
                            <FormControl id="date" isRequired>
                                <FormLabel>Date and Time</FormLabel>
                                <Input name='date' type="datetime-local" onChange={(event) => setDate(event.target.value)} />
                                {!date && <Text fontSize='sm' color='red.400'>Select date and time.</Text>}
                            </FormControl>
                        </Stack>
                    </ModalBody>

                    <ModalFooter>
                        <Button colorScheme='yellow' variant={'outline'} mr={3} onClick={onClose}>
                            Close
                        </Button>
                        <Button colorScheme={'yellow'} isLoading={isUpdating} isDisabled={isUpdating || !date} onClick={updateDeliveryDate}>Update</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
};